import { useEffect, useState } from "react";
import api from "@/lib/api";

const SIGNAL = { "BUY NOW": "#5FB878", WAIT: "#D4AF37", SKIP: "#E63946" };

export default function BuyWhen() {
  const [windows, setWindows] = useState([]);
  useEffect(() => { api.get("/buy-when").then((r) => setWindows(r.data.windows || [])); }, []);
  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 md:py-16">
      <div className="eyebrow mb-4">BUY WHEN ENGINE</div>
      <h1 className="font-display text-4xl md:text-6xl font-bold leading-[0.95] mb-3">IS NOW THE WRONG TIME TO BUY?</h1>
      <p className="text-stone-400 max-w-xl mb-10">Most weeks are the wrong week. Here's when prices actually drop. Seasonality is a pattern — not a guarantee.</p>
      <div className="border-l border-t hairline grid md:grid-cols-2">
        {windows.map((w) => (
          <div key={w.id} data-testid={`buywhen-${w.category.toLowerCase().replace(/[^a-z]+/g, "-")}`} className="border-r border-b hairline p-7">
            <div className="flex items-center justify-between mb-3">
              <h3 className="font-display text-2xl font-semibold">{w.category}</h3>
              <span className="font-label text-xs tracking-widest px-3 py-1 border" style={{ color: SIGNAL[w.signal], borderColor: SIGNAL[w.signal] }}>
                {w.signal}
              </span>
            </div>
            <p className="text-sm text-stone-400 mb-4">{w.note}</p>
            <div className="flex flex-wrap gap-4">
              <div>
                <div className="font-label text-[10px] tracking-widest text-stone-500 mb-1">BEST MONTHS</div>
                <div className="font-label text-xs text-stone-200">{w.best_months?.join(" · ")}</div>
              </div>
              <div>
                <div className="font-label text-[10px] tracking-widest text-stone-500 mb-1">SALES</div>
                <div className="font-label text-xs text-stone-200">{w.sales?.join(" · ")}</div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
